import {
  CART_PLACEMENT_CONTAINER_TYPES,
  PlacementContainerType,
} from "@redotech/redo-storefront-common/widget-config";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { baseCustomerEventSchema, CustomerEventType } from "./base";
import { coverageTreatmentIdSourceSchema } from "./coverage-treatment-id-source";

export const CoverageWidgetRenderedShoppingEventSchema_ =
  baseCustomerEventSchema.extend({
    eventType: z.literal(CustomerEventType.COVERAGE_WIDGET_RENDERED),
    anonymousId: z.string(),
    sessionId: z.string(),
    coverageTreatmentId: z.string(),
    coverageTreatmentIdSource: coverageTreatmentIdSourceSchema,
    cartSurface: createEnum(CART_PLACEMENT_CONTAINER_TYPES, {
      enumName: "PlacementContainerType",
      isPartial: true,
      originalEnum: PlacementContainerType,
    }),
    eventId: z.string(),
  });
